import { useEffect } from 'react'
import { Redirect, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import usePhoto from 'photo-module/photo/core/usePhoto'
import apm from 'shared-module/monitoring/apm'
import useSelectedCamera from 'camera-module/camera/core/useSelectedCamera'
import usePhotoError from 'photo-module/photo/core/usePhotoError'
import messageActions from 'shared-module/message/messageActions'
import ActionsBar from 'spypoint/src/photos-module/photos/ui/SpypointViewerPanel'
import PhotoViewerContainer from 'spypoint/src/photos-module/photos/ui/photo-viewer-preview/SpypointPhotoViewerContainer'
import PhotoGalleryTopBar from 'spypoint/src/photos-module/photos/ui/photos-gallery/PhotoGalleryTopBar'
import useGalleryInitializer from 'photo-module/photos/core/useGalleryInitializer'

const useStyles = makeStyles(theme => ({
  root: {
    background: '#000',
    height: '100vh',
    width: '100vw',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    userSelect: 'none',
    margin: 0,
    padding: 0,
    position: 'fixed',
    top: '130px',
    left: 0,
    right: 0,
    zIndex: 1000,
    [theme.breakpoints.only('sm')]: {
      flexDirection: 'column',
      top: '140px',
    },
    [theme.breakpoints.only('xs')]: {
      flexDirection: 'column',
      top: '115px',
    },
  },
  mobileContainer: {
    width: '100%',
    height: 'calc(100vh - 150px)',
    [theme.breakpoints.only('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      height: 'calc(60vh - 84px)',
      width: '100%',
      minHeight: '300px',
    },
    [theme.breakpoints.only('xs')]: {
      display: 'flex',
      flex: 0.4,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
    },
  },
  mobilePanel: {
    [theme.breakpoints.down('sm')]: {
      flex: 0.6,
      width: '100% !important',
      margin: '0 !important',
      order: 2,
      overflow: 'auto',
    },
  },
}))

const PhotoPreview = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { cameraId, photoId } = useParams()
  const photo = usePhoto(cameraId, photoId)
  const photoError = usePhotoError()
  const selectedCamera = useSelectedCamera()

  // Initialize gallery photos if needed (for direct URL access)
  useGalleryInitializer()

  useEffect(() => {
    if (selectedCamera) {
      apm.log('photo-viewer', [{ cameraModel: selectedCamera.status.model }])
    }
  }, [selectedCamera, photoId])

  useEffect(() => {
    dispatch(messageActions.showError(t(photoError)))
  }, [photoError, dispatch, t])

  if (photoError) {
    return <Redirect push to={`/camera/${cameraId}`} />
  }

  return (photo
    ? (
      <>
        <PhotoGalleryTopBar />
        <div className={classes.root}>
          <div className={classes.mobileContainer}>
            <PhotoViewerContainer photo={photo} />
          </div>
          <div className={classes.mobilePanel}>
            <ActionsBar photo={photo} />
          </div>
        </div>
      </>
      )
    : null
  )
}

export default PhotoPreview
